module.exports = __webpack_public_path__ + "static/media/Banner_1.c413f43e.jpg";